import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Football Americano",
    Baseball: "Baseball",
    Basketball: "Pallacanestro",
    Boxing: "Pugilato",
    Chess: "Scacchi",
    Cricket: "Cricket",
    Darts: "Freccette",
    Entertainment: "Divertimento",
    "E-Sports": "eSport",
    Football: "Calcio",
    "Formula 1": "Formula 1",
    "Gaelic Football": "Calcio Gaelico",
    "Generic Sport": "Sport generico",
    Golf: "Golf",
    "Greyhound Racing": "Greyhound",
    Handball: "Pallamano",
    "Ice Hockey": "Hockey su ghiaccio",
    IndyCar: "Indy",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politica",
    "Rugby League": "Rugby League",
    "Rugby Union": "Rugby a 15",
    Snooker: "Snooker",
    "Table Tennis": "Tennistavolo",
    Tennis: "Tennis",
    "Virtual Football": "Calcio Virtuale",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} per vincere",
    WinFirstRound: "{name} per vincere il primo round",
    FirstTouchdown: "{name} per segnare prima un touchdown",
    FirstTry: "{name} per segnare prima una meta",
    TotalGoals: "{name} Totale gol",
    TotalRuns: "{name} Totali Runs",
    TotalPoints: "{name} Totale Punti",
    TopBatsman: "{name} per essere il miglior battitore",
    TopBowler: "{name} per essere il miglior giocatore di bocce",
    FirstScore: "{name} per segnare per primo"
  },
  PromoTexts: {
    Pick: "Fai le tue scelte",
    Bet: "Scommessa",
    Pays: "Pagamento"
  },
  DateTimeTexts: {
    Today: "Oggi",
    Tomorrow: "Domani",
    Live: "Live"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Fai le tue scelte",
    Return: "Pagamento",
    Stake: "Scommessa",
    Draw: "X"
  },
  H2HTexts: {
    goals_scored: "Gol segnati",
    shots: "Tiri",
    shots_on_target: "Tiri in porta",
    ball_possession: "Possesso Palla",
    goals_conceded: "Gol subiti",
    "Per match": "Per partita",
    H2H: "TaT",
    W: "V",
    D: "P",
    L: "S",
    T: "P",
    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
